import { isSuccessful } from '../data/OHMRepository'

import { RepositoryFactory } from '../data/RepositoryFactory'
import { debug } from '../util/log'

const OHMRepository = RepositoryFactory.get('ohm')

export const hintModule = {
  namespaced: true,
  state: () => ({
    hintFunctions: {},
    hintFunctionPromise: null,

    hintFunctionMap: {},
    hintFunctionMapPromise: null,

    impact: {}, // impact data for each hint statement for the current id_link
    impactLoading: false,
    selected: null,
    selectedStatement: null,

    articleImpact: {},
    articleImpactLoading: false,
  }),
  mutations: {
    setHintFunctions(state, hintFunctions) {
      const funcs = {}
      Object.keys(hintFunctions).forEach((i) => {
        const hf = hintFunctions[i]
        if (hf.args) {
          // Hint function arguments are stored as plain JSON in database
          hf.args = JSON.parse(hf.args)
        }
        funcs[hf.id] = hf
      })
      state.hintFunctions = funcs
    },
    setHintFunctionMap(state, map) {
      state.hintFunctionMap = map
    },
    setImpact(state, hintImpact) {
      debug("store/hint: setImpact called")
      const hints = {}
      for (const impact of hintImpact) {
        if (!(impact.id_hint in hints)) {
          hints[impact.id_hint] = {}
        }
        hints[impact.id_hint][impact.hash] = {
          potential: impact.potential_impact,
          real: impact.real_impact,
          positive: impact.positive
        }
      }
      state.impact = hints
    },
    setImpactLoading(state, loading) {
      state.impactLoading = loading
    },
    setSelectedStatement(state, statement) {
      state.selectedStatement = statement
    },
    setSelectedHint(state, hint) {
      state.selected = hint
    },
    addStatementToSelectedHint(state, statement) {
      state.selected.statements.push(statement)
    },
    deleteStatementFromSelectedHint(state, statementPosition) {
      for (let i = 0; i < state.selected.statements.length; i++) {
        if (statementPosition === i) {
          state.selected.statements.splice(i, 1)
          return true
        }
      }
      return false
    },
    setArticleImpact(state, impact) {
      state.articleImpact = impact
    }
  },
  actions: {
    getHintFunctions({ commit, state }) {
      if (!state.hintFunctionPromise) {
        state.hintFunctionPromise = new Promise((resolve, reject) => {
          if (Object.keys(state.hintFunctions).length > 0) {
            return Promise.resolve()
          }
          OHMRepository.getHintFunctions()
            .then(response => {
              if (isSuccessful(response) && response.data.hint_functions) {
                commit('setHintFunctions', response.data.hint_functions)
                resolve()
              } else {
                reject(response)
              }
            })
            .catch((error) => {
              reject(error)
            })
            .then(() => {
              state.hintFunctionPromise = null
            })
        })
      }
      return state.hintFunctionPromise
    },
    getHintFunctionMap({ commit, state }) {
      if (!state.hintFunctionMapPromise) {
        state.hintFunctionMapPromise = new Promise((resolve, reject) => {
          if (Object.keys(state.hintFunctionMap).length > 0) {
            return Promise.resolve()
          }
          OHMRepository.getHintFunctionMap()
          .then(response => {
            if (isSuccessful(response) && response.data.map) {
              commit('setHintFunctionMap', response.data.map)
              resolve()
            } else {
              reject(response)
            }
          })
          .then(() => state.hintFunctionMapPromise = null)
        })
      }
      return state.hintFunctionMapPromise
    },
    getArticleImpact({ commit, state }, { id_site, crc32, id_links }) {
      return new Promise((resolve, reject) => {
        if (state.articleImpactLoading) {
          return resolve()
        }
        state.articleImpactLoading = true
        OHMRepository.getStatementArticleImpact(id_site, crc32, id_links)
          .then((response) => {
            if (response.data.impact) {
              console.log("article impact:")
              console.log(response.data.impact)
              commit('setArticleImpact', response.data.impact)
              resolve()
            }
          })
          .catch((error) => {
            reject(error)
          })
          .then(() => {
            state.articleImpactLoading = false
          })
      })
    },
  }
}
